module.exports = __webpack_public_path__ + "static/media/DPL_05.fa37ccf2.jpg";